import { lazy } from 'react';

export const nonCaseRoutes = () => [
  {
    path: '/',
    page: 'CorneaConnect',
    component: lazy(() => import('src/views/Home')),
  },
  {
    page: 'Worksheet',
    path: '/case/worksheet',
    component: lazy(() => import('src/views/case/NewCaseWorksheetView')),
    permission: {
      readPermission: 'read:referralWorksheet',
      createPermission: 'create:referralWorksheet',
      updatePermission: 'update:referralWorksheet',
    },
  },

  {
    form: 'adminRole',
    page: 'Role Management',
    path: '/admin/roles/:roleId',
    component: lazy(() => import('src/views/admin/RoleView')),
    permission: {
      readPermission: 'read:role',
      createPermission: 'create:role',
      updatePermission: 'update:role',
    },
  },
  {
    form: 'apiKey',
    page: 'API Key Management',
    path: '/admin/apiKeys/create',
    component: lazy(() => import('src/views/admin/ApiKeyView')),
    permission: {
      readPermission: 'create:apiKey',
      createPermission: 'create:apiKey',
      updatePermission: 'create:apiKey',
    },
  },
  {
    form: 'apiKey',
    page: 'API Key Management',
    path: '/admin/apiKeys/:apiKeyId',
    component: lazy(() => import('src/views/admin/ApiKeyView')),
    permission: {
      readPermission: 'read:apiKey',
      createPermission: 'create:apiKey',
      updatePermission: 'update:apiKey',
    },
  },
  {
    form: 'adminUser',
    page: 'Create User',
    path: '/admin/users/create',
    component: lazy(() => import('src/views/admin/UserManagementView')),
    permission: {
      // this is only available to users with create
      readPermission: 'create:userManagement',
      createPermission: 'create:userManagement',
      updatePermission: 'create:userManagement',
    },
  },
  {
    form: 'selfSettings',
    page: 'Settings',
    path: '/settings',
    component: lazy(() => import('src/views/settings/UserSettingsView')),
    permission: {
      readPermission: 'read:selfSettings',
      createPermission: 'update:selfSettings',
      updatePermission: 'update:selfSettings',
    },
  },
  {
    form: 'adminUser',
    page: 'Modify User',
    path: '/admin/users/:userId',
    component: lazy(() => import('src/views/admin/UserManagementView')),
    permission: {
      readPermission: 'read:userManagement',
      createPermission: 'create:userManagement',
      updatePermission: 'update:userManagement',
    },
  },
  {
    page: 'User Management',
    path: '/admin/users',
    component: lazy(() => import('src/views/admin/UserListView')),
  },
  {
    page: 'API Key Management',
    path: '/admin/apiKeys',
    component: lazy(() => import('src/views/admin/ApiKeyListView')),
  },
  {
    page: 'Role Management',
    path: '/admin/roles',
    component: lazy(() => import('src/views/admin/RoleListView')),
  },
  {
    page: 'Access Logs',
    path: '/admin/accessLogs',
    component: lazy(() => import('src/views/admin/AccessLogListView')),
  },
  {
    path: '/notes',
    page: 'Notes',
    component: lazy(() => import('src/views/notes/NotesView')),
    permission: {
      readPermission: 'read:notes',
      createPermission: 'create:notes',
      updatePermission: 'update:notes',
    },
  },
  {
    path: '/notes/label/:customLabel/:noteId?',
    page: 'Notes',
    component: lazy(() => import('src/views/notes/NotesView')),
    permission: {
      readPermission: 'read:notes',
      createPermission: 'create:notes',
      updatePermission: 'update:notes',
    },
  },
  {
    path: '/notes/:systemLabel/:noteId?',
    page: 'Notes',
    component: lazy(() => import('src/views/notes/NotesView')),
    permission: {
      readPermission: 'read:notes',
      createPermission: 'create:notes',
      updatePermission: 'update:notes',
    },
  },
  {
    path: '/notes/all',
    page: 'Notes',
    component: lazy(() => import('src/views/notes/NotesView')),
    permission: {
      readPermission: 'read:notes',
      createPermission: 'create:notes',
      updatePermission: 'update:notes',
    },
  },
  {
    path: '/checklist',
    page: 'Checklist',
    component: lazy(
      () => import('src/views/checklist/ChecklistView/CaseChecklist'),
    ),
    permission: {
      readPermission: 'read:checklist',
      createPermission: 'create:checklist',
      updatePermission: 'update:checklist',
    },
  },
  {
    path: '/inbox',
    page: 'Inbox',
    component: lazy(() => import('src/views/inbox')),
  },
  {
    path: '/tasks',
    page: 'Tasks',
    component: lazy(() => import('src/views/tasks')),
  },
  // Not official
  {
    form: 'settings-notifications',
    page: 'Notification Settings',
    path: '/settings/notifications',
    component: lazy(() => import('src/views/settings/notifications')),
  },
  {
    form: 'lookupTables',
    page: 'Lookup Table Maintenance',
    path: '/admin/lookupTables',
    component: lazy(() => import('src/views/lookupTables')),
    permission: {
      readPermission: 'read:lookupManagement',
      createPermission: 'create:lookupManagement',
      updatePermission: 'update:lookupManagement',
    },
  },
  {
    form: 'referenceTables',
    page: 'Reference Table Maintenance',
    path: '/admin/referenceTables',
    component: lazy(() => import('src/views/referenceTables')),
    permission: {
      readPermission: 'read:referenceManagement',
      createPermission: 'create:referenceManagement',
      updatePermission: 'update:referenceManagement',
    },
  },
  {
    page: 'Template Management',
    path: '/admin/templates',
    component: lazy(() => import('src/views/admin/TemplateManagementView')),
    permission: {
      readPermission: 'read:referenceManagement',
      createPermission: 'create:referenceManagement',
      updatePermission: 'update:referenceManagement',
    },
  },
  {
    page: 'Organizations',
    path: '/admin/organizations',
    component: lazy(
      () => import('src/views/organizationsV2/OrganizationTableV2'),
    ),
    permission: {
      readPermission: 'read:referenceManagement',
      createPermission: 'create:referenceManagement',
      updatePermission: 'update:referenceManagement',
    },
  },
  {
    page: 'Organizations',
    path: '/admin/organizations/:activeOrganizationId',
    component: lazy(() => import('src/views/organizationsV2/OrganizationV2')),
    permission: {
      readPermission: 'read:referenceManagement',
      createPermission: 'create:referenceManagement',
      updatePermission: 'update:referenceManagement',
    },
  },
  {
    form: 'groups',
    page: 'Groups',
    path: '/admin/groups',
    component: lazy(() => import('src/views/groups')),
    permission: {
      readPermission: 'read:referenceManagement',
      createPermission: 'create:referenceManagement',
      updatePermission: 'update:referenceManagement',
    },
  },
  {
    form: 'groups',
    page: 'Groups',
    path: '/admin/groups/:activeGroupId',
    component: lazy(() => import('src/views/groups/Group')),
    permission: {
      readPermission: 'read:referenceManagement',
      createPermission: 'create:referenceManagement',
      updatePermission: 'update:referenceManagement',
    },
  },
  {
    page: 'Reports',
    path: '/reports',
    component: lazy(() => import('src/views/reports/ReportView')),
    permission: {
      readPermission: 'read:reports',
    },
  },
];
